import MuiDivider, { DividerProps as MuiDividerProps } from '@mui/material/Divider';

const Divider = (props: MuiDividerProps): JSX.Element => {
  return <MuiDivider {...props} />;
};

export default Divider;

export { Divider };
